/**
 * @class BackendAPIConfig
 * @property {string} endpoint
 */
export class BackendAPIConfig {
    /**
     * constructor BackendAPIConfig
     * @constructor
     * @param {Object} Object
     * @param {string} Object.endpoint
     */
    constructor({ endpoint }) {
        this.endpoint = endpoint
    }
}

/**
 * @class AlbionIDSiteConfig
 * @property {any} siteUrl
 */
export class AlbionIDSiteConfig {
    /**
     * constructor AlbionIDSiteConfig
     * @constructor
     * @param {Object} Object
     * @param {any} Object.isUseMembersCard
     * @param {String} Object.siteUrl
     */
    constructor({ isUseMembersCard = false, siteUrl }) {
        /** LINE会員証利用可否 */
        this.isUseMembersCard = isUseMembersCard
        /** サイトURL */
        this.siteUrl = siteUrl
    }
}
